<template>
  <div>
    <div v-if="label != ''" class="eq-ask row">
      <strong class="col-12 ml-3 label-vision">{{ label }}:</strong>
    </div>
    <div class="form-group mb-5 ml-3 w-100">
      <CustomTextArea
        :id="id"
        :class="{ 'was-Invalidated': error }"
        :rows="rows"
        :disabled="disabled"
        :placeholder="placeholder"
        :required="required"
        :minlength="minlength"
        :maxlength="maxlength"
        :value="value"
        :error="errorDesc"
        :custom-error-msg="customErrorMsg"
        @input="updateValue"
      />
    </div>
  </div>
</template>

<style scoped>
span.invalid:not(input) {
  color: #e85c5c;
}
.form-control-icon-normal {
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
  color: rgba(63, 91, 96, 0.3);
}
.form-control-icon-invalid {
  color: #e85c5c;
  position: absolute;
  top: 9px;
  right: 10px;
  font-size: 19px;
}
.input-label {
  height: 19px;
  text-align: left;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
  line-height: 19px;
}
.label-vision {
  margin-bottom: 10px;
}
</style>

<script>
import CustomTextArea from '@/components/common/CustomTextArea.vue';

export default {
  meta: {
    description: 'Componente para entrada de texto multilínea con icono.',
    slots: {
      default: {
        type: 'component',
        valid: [],
      },
    },
  },
  props: {
    id: {
      type: String,
      default: 'customTextArea',
      meta: {
        description: 'Id del Componente FormTextAreaVisionTab3',
        example: 'idFormTextAreaVisionTab3',
      },
    },
    label: {
      type: String,
      default: '',
      meta: {
        description: 'Control para mostrar texto',
        example: 'Texto requerido',
      },
    },
    placeholder: {
      type: String,
      default: '',
      meta: {
        description: 'Texto de referencia en el textarea',
        example: 'Texto requerido',
      },
    },
    value: {
      type: String,
      default: '',
      meta: {
        description: 'Parámetro de entrada en el textarea',
        example: 'Texto requerido',
      },
    },
    required: {
      type: String,
      default: function() {
        return 'required';
      },
      meta: {
        description: 'Estado requerido',
        example: 'Texto requerido',
      },
    },
    disabled: {
      type: Boolean,
      required: false,
      meta: {
        description: 'Estado Disabled',
        example: 'true',
      },
    },
    minlength: {
      type: Number,
      default: 0,
      required: false,
      meta: {
        description: 'Logitud mínima requerida',
        example: 'Texto requerido',
      },
    },
    maxlength: {
      type: Number,
      default: 0,
      required: false,
      meta: {
        description: 'Logitud máxima requerida',
        example: 'Texto requerido',
      },
    },
    rows: {
      type: Number,
      default: 5,
      meta: {
        description: 'Especifica el número de líneas de texto visibles',
        example: '10',
      },
    },
    error: {
      type: String,
      default: '',
      meta: {
        description: 'Estado Error',
        example: 'Texto requerido',
      },
    },
    // Bind error CustomTextArea.
    errorDesc: {
      type: String,
      default: '',
      meta: {
        description: 'Error encontrado',
        example: 'Texto requerido',
      },
    },
    icon: {
      type: String,
      default: '',
      meta: {
        description: 'Propiedad para el icono',
        example: 'fas fa-times',
      },
    },
    customErrorMsg: {
      type: String,
      default: function() {
        return this.errorDesc;
      },
      meta: {
        description: 'Mensaje de error encontrado',
        example: 'Texto requerido',
      },
    },
  },
  methods: {
    updateValue: function(value) {
      this.$emit('input', value);
    },
  },
  computed: {},
  components: {
    CustomTextArea,
  },
};
</script>
